import axios from "../../../util/axios";

export default {

    /* 同步客户信息 */
    syncCustomer: (data) => axios.get({url: '/third/common/customer/syncCustomer', data: data})

}